import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {JWTService} from 'src/app/authentication/jwt.service';
import {PasteboxService} from 'src/app/services/pastebox.service';
import {HttpErrorHandlerService} from '../../http-error-handler.service';
import {TransmissionService} from '../transmission.service';
// import { ProductDetailsResponse } from '../../interface/product-details/product-details-response';
import {ProductInFinishProduct} from 'src/app/product-details/interface/product-in-finish-product';
// import { FabricProcuct, FabrichedProcuct } from 'src/app/product-details/interface/fabric-procuct';
import {ProductDetailsResponseForFabric, ProductDetailsResponseForFinish} from '../../interface/product-details/product-details-response';
import {FinishedProcuct} from 'src/app/product-details/interface/finished-procuct';
import {FabricProcuct} from 'src/app/product-details/interface/fabric-procuct';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsTransmissionService extends TransmissionService {

	constructor(
		_http: HttpClient,
		_httpErrorHandler: HttpErrorHandlerService,
		_jwt: JWTService,
        _pastebox: PasteboxService
	) {
		super(_http, _httpErrorHandler, _jwt, _pastebox);
	}
	getProductDetails(
		url:string,
		onPreExecute: () => void,
		onPostExecute: (response: FabricProcuct|FinishedProcuct) => void,
		onSuccess: (response: FabricProcuct|FinishedProcuct) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	){
		// debugger
		this.executeGetPayload<ProductDetailsResponseForFinish|ProductDetailsResponseForFabric,FabricProcuct|FinishedProcuct>(
			url,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			'finishedProduct',
			false // :TODO fales
		);
	}

	getProductDetailsFinish(
		url:string,
		onPreExecute: () => void,
		onPostExecute: (response: ProductInFinishProduct) => void,
		onSuccess: (response: ProductInFinishProduct) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	){
		// debugger
		this.executeGetPayload<ProductDetailsResponseForFinish,ProductInFinishProduct>(
			url,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			'finishedProduct',
			false // :TODO fales
		);
	}

	getProductDetailsFabric(
		url:string,
		onPreExecute: () => void,
		onPostExecute: (response: ProductInFinishProduct) => void,
		onSuccess: (response: ProductInFinishProduct) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	){
		// debugger
		this.executeGetPayload<ProductDetailsResponseForFabric,ProductInFinishProduct>(
			url,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			'fabricProduct',
			false // :TODO fales
		);
	}
}
